import { TxResponse } from "secretjs";

const decodeTxMsg = (tx: TxResponse) => {
  try {
    const data = new TextDecoder().decode(tx.data[0]);
    const arr = data.split("{");
    arr.shift();
    const arr2 = ("{" + arr.join("{")).split("}");
    arr2.pop();
    const result = arr2.join("}") + "}";

    return JSON.parse(result);
  } catch (err) {
    return {};
  }
};

export default decodeTxMsg;
